const text = (value) => (value === null || value === undefined ? '' : String(value).trim());

export const SYNTHETIC_BAC_PREFIX = '99999';

export const isSyntheticBac = (value) => text(value).startsWith(`${SYNTHETIC_BAC_PREFIX}-`);
